import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  apartmentSchema,
  getApartmentSchemaWithAdditionalFields,
} from "./apartment";
import { getLeaseSchemaAdditionalFields, leaseSchema } from "./lease";

export const leaseWithApartmentSchema = leaseSchema.extend({
  apartment: apartmentSchema,
});

export type LeaseWithApartment = z.infer<typeof leaseWithApartmentSchema>;

export function getLeaseWithApartmentSchemaWithAdditionalFields(additionalFields: {
  lease: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof leaseWithApartmentSchema {
  return getLeaseSchemaAdditionalFields(additionalFields).extend({
    apartment: getApartmentSchemaWithAdditionalFields(additionalFields),
  });
}
